/* eslint-disable no-empty-pattern */
/* eslint-disable no-shadow */
/* eslint-disable import/no-cycle */
import {
  ActionTree, Module, MutationTree, GetterTree
} from 'vuex';
import VehicleLevel from '@/enums/VehicleLevel';
import VehicleType from '@/enums/VehicleType';
import CampaignVehicleLevel from '@/enums/CampaignVehicleLevel';
import VehicleModuleOptions from '@/models/VehicleModuleOptions';
import SearchQueryState from '../states/search-query-state';
import ISearchQueryState from '../states/interfaces/search-query-state.d';
import IRootState from '../states/interfaces/index.d';

export const state: ISearchQueryState = new SearchQueryState();

export const getters: GetterTree<ISearchQueryState, IRootState> = {
  searchQuery: (state) => state.searchQuery
};
export const mutations: MutationTree<ISearchQueryState> = {
  setBodystyles: (state, selectedBodystyle: string[] | null) => {
    state.searchQuery.bodystyles = selectedBodystyle;
  },
  setDerivativeId: (state, selectedDerivativeId: number | null) => {
    state.searchQuery.derivativeId = selectedDerivativeId;
  },
  setDoors: (state, selectedDoors: number | null) => {
    state.searchQuery.doors = selectedDoors;
  },
  setFuelTypes: (state, selectedFuelType: string[] | null) => {
    state.searchQuery.fuelTypes = selectedFuelType;
  },
  setManufacturerIds: (state, selectedManufacturerIds: number[] | null) => {
    state.searchQuery.manufacturerIds = selectedManufacturerIds;
  },
  setRangeId: (state, selectedRangeId: number | null) => {
    state.searchQuery.rangeIds = selectedRangeId;
  },
  setTransmission: (state, selectedTransmission: string | null) => {
    state.searchQuery.transmissions = selectedTransmission;
  },
  setTrims: (state, selectedTrim: string[] | null) => {
    state.searchQuery.trims = selectedTrim;
  },
  setVehicleLevel: (state, vehicleLevel: VehicleLevel) => {
    state.searchQuery.vehicleLevel = vehicleLevel;
  },
  setVehicleType: (state, vehicleType: VehicleType) => {
    state.searchQuery.vehicleType = vehicleType;
  },
  setCampaignVehicleLevel: (state, campaignVehicleLevel: CampaignVehicleLevel) => {
    state.searchQuery.campaignVehicleLevel = campaignVehicleLevel;
  },
  setEngineSize: (state, engineSize: number) => {
    state.searchQuery.engineSize = engineSize;
  },
  setBasicColour: (state, basicColour: string | null) => {
    state.searchQuery.basicColour = basicColour;
  },
  setSpecificColour: (state, specificColour: string | null) => {
    state.searchQuery.specificColour = specificColour;
  },
  setModelId: (state, modelId: number | null) => {
    state.searchQuery.modelId = modelId;
  }
};
export const actions: ActionTree<ISearchQueryState, IRootState> = {
  submitModelId({ commit }, modelId: number | null) {
    commit('setModelId', modelId);
  },
  submitBodystyles({ commit }, selectedBodystyle: string[] | null) {
    commit('setTrims', null);
    commit('setBodystyles', selectedBodystyle);
  },
  submitDerivativeId({ commit }, selectedDerivativeId: number | null) {
    commit('setDerivativeId', selectedDerivativeId);
  },
  submitDoors({ commit }, selectedDoors: string | null) {
    commit('setDoors', selectedDoors);
  },
  submitFuelTypes({ commit }, selectedFuelType: string[] | null) {
    commit('setFuelTypes', selectedFuelType);
  },
  submitManufacturerIds({ commit }, selectedManufacturerIds: number[] | null) {
    commit('setManufacturerIds', selectedManufacturerIds);
  },
  submitRangeId({ commit }, selectedRangeId: number | null) {
    commit('setRangeId', selectedRangeId);
  },
  submitTransmission({ commit }, selectedTransmission: string | null) {
    commit('setTransmission', selectedTransmission);
  },
  submitTrims({ commit }, selectedTrim: string[] | null) {
    commit('setTrims', selectedTrim);
  },
  submitVehicleLevel({ commit }, vehicleLevel: VehicleLevel) {
    if (vehicleLevel) {
      commit('setVehicleLevel', vehicleLevel);
    }
  },
  submitVehicleType({ commit }, vehicleType: VehicleType) {
    commit('setVehicleType', vehicleType);
  },
  submitCampaignVehicleLevel({ commit }, campaignVehicleLevel: CampaignVehicleLevel) {
    commit('setCampaignVehicleLevel', campaignVehicleLevel);
  },
  submitEngineSize({ commit }, engineSize: string) {
    commit('setEngineSize', engineSize);
  },
  submitBasicColour({ commit }, basicColour: string | null) {
    commit('setBasicColour', basicColour);
  },
  submitSpecificColour({ commit }, specificColour: string | null) {
    commit('setSpecificColour', specificColour);
  },
  createNewModuleInstance({ rootState }, options: VehicleModuleOptions) {
    const newStateInstance: ISearchQueryState = new SearchQueryState();
    newStateInstance.searchQuery.vehicleType = options.vehicleType;
    newStateInstance.searchQuery.vehicleLevel = options.vehicleLevel;

    if (options.restrictVehicles) {
      newStateInstance.searchQuery.manufacturerIds = rootState.initialSettingsModule.initialSettings.allowedManufacturerIds;
    }

    this.registerModule(`searchQueryModule${options.moduleKey}`, {
      state: newStateInstance,
      getters,
      actions,
      mutations,
      namespaced: true
    });
  }
};
export const searchQueryModule: Module<ISearchQueryState, IRootState> = {
  state,
  actions,
  mutations,
  getters,
  namespaced: true
};
